<div class="confirm-dialog">
  <div class="dialog-icon">
    <img *ngIf="data.errorType == 0" src="./assets/images/icons/planner/warning-msg-icon.svg" alt="">
    <img *ngIf="data.errorType == 1" src="./assets/images/icons/planner/warning-icon.svg" alt="">
  </div>
  <div>
    <div mat-dialog-title>
      <h2>{{"reservations.Table Problem" | translate}}</h2>
    </div>

    <div *ngFor="let item of data.reservationResponse.checkresult">
      <p>{{item}}</p>
    </div>

    <div class="data-list">
      <h4>{{'reservations.Recommendations' | translate}}</h4>
      <ul>
        <li *ngFor="let item of data.reservationResponse.checkRecommendation">
          {{item}}
        </li>
      </ul>
    </div>
  </div>
</div>

<mat-dialog-actions>
  <button mat-button color="primary" mat-dialog-close *ngIf="data.errorType == 0">
    {{ 'swalMsg.I got it' | translate }}
  </button>

  <ng-container *ngIf="data.errorType == 1">
    <button mat-button class="btn-grey"
      [mat-dialog-close]="!loading"
      [disabled]="loading">
      {{"reservations.Edit Reservation" | translate}}
    </button>

    <button mat-button color="primary"
        *ngIf="data.reservationResponse.canReserveAnyWay"
        [disabled]="loading"
        (click)="saveRecord()"
        [class.loading]="loading">
      {{ 'reservations.Reserve Anyway' | translate }}
    </button>
  </ng-container>
</mat-dialog-actions>
